module.exports = __webpack_public_path__ + "31a44543688ad6dd2e0425b1bb2adb08.jpg";